var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5299 0.528594C8.79025 0.268245 9.21236 0.268245 9.47271 0.528594C9.73306 0.788944 9.73306 1.21105 9.47271 1.4714L5.47271 5.4714C5.22032 5.72379 4.81393 5.73262 4.55082 5.49144L0.550818 1.82477C0.279406 1.57597 0.261071 1.15426 0.509866 0.882849C0.758661 0.611436 1.18037 0.593101 1.45179 0.841896L4.98125 4.07724L8.5299 0.528594Z",
    fill: "#0C1A4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.5edfacd85b49f71a670100d87205c9b8.svg";
export { ForwardRef as ReactComponent };